export default {

  // 商品列表
  getProductList(params, success) {
    Request.GET('/commodity', params, response => success(response));
  },

  // 查询商品详情
  getProductDetail(id, success) {
    Request.GET(`/commodity/${id}`, null, response => success(response));
  },

  // 删除商品
  deleteProduct(id, success) {
    Request.DEL(`/commodity/${id}`, null, response => success(response));
  },

  // 上架、下架商品
  setProductStatus(params, success) {
    Request.PUT('/commodity/status', params, response => success(response));
  },

  // 新增商品
  addProduct(params, success) {
    Request.POST('/commodity', params, response => success(response));
  },

  // 修改商品
  editProduct(id, params, success) {
    Request.PUT(`/commodity/${id}`, params, response => success(response));
  },
};



// WEBPACK FOOTER //
// ./src/api/productApi.js